<template>
  <div class="ds-component-info">
    <p>
      <label style="width:100px;display:inline-block">控件类型：</label>
      {{ info.caption }}
    </p>
    <p>
      <label style="width:100px;display:inline-block">元数据标识：</label>
      {{ info.id ||'无'}}
    </p>
    <p>
      <label style="width:100px;display:inline-block">元数据名称：</label>
      {{ info.name||'无' }}
    </p>
    <!-- <p>
      <label style="width:100px;display:inline-block">元数据类型：</label>
      <template v-if="info.typeValue">
        {{ info.typeText || '' }} 
        | {{ info.typeValue || '' }}
      </template>
      <template v-else>
        无
      </template>
    </p> -->
  </div>
</template>

<script>
export default {
  name: "DsfComponentInfo",
  props: {
    info: {
      type: Object,
      default() {
        return {};
      }
    }
  }
};
</script>